import { bind } from 'bind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import FieldInteger from '../../../../../form/field/field-integer';
import FieldSelect from '../../../../../form/field/field-select';
import QuickPickContainer from '../../../../quick-pick/container';
import type TimeDurationPickerProps from './interfaces/time-duration-picker-props';

@observer
class TimeDurationPicker extends Component<TimeDurationPickerProps> {
  @observable
  unit = 0;
  @observable
  duration = 1;

  @bind
  onChangeUnit(e: any) {
    this.unit = e.target.value;
  }

  @bind
  onChangeDuration(value: number) {
    if (!isNaN(value) && value >= 0) {
      this.duration = value;
    }
  }

  render() {
    const { duration, unit } = this;
    const { units } = this.props;

    let unitsDropdown = units.map((u: string, idx: string) => {
      const uText = duration === 1 ? u.slice(0, -1) : u;
      return { payload: idx, text: uText };
    });

    return (
      <QuickPickContainer {...this.props} title={'Time Duration'}>
        <div id={'time-picker-sheath'}>
          <span id={'count'}>
            <FieldInteger
              min={0}
              label={'Duration'}
              value={duration}
              onChange={this.onChangeDuration}
            />
          </span>
          <span id={'unit'}>
            <FieldSelect
              label={'Unit'}
              items={unitsDropdown}
              value={unit}
              onChange={this.onChangeUnit}
            />
          </span>
        </div>
      </QuickPickContainer>
    );
  }
}

export default TimeDurationPicker;
